import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressBarModule } from '../../notes/progress-bar/progress-bar.module';
import { ProgressBarGridComponent } from './progress-bar-grid.component';

@NgModule({
  declarations: [ProgressBarGridComponent],
  imports: [CommonModule, ProgressBarModule],
  exports: [ProgressBarGridComponent],
})
export class ProgressBarGridModule {}
